import * as React from 'react';

import GenericIconProps from './_icon.type';

function WhatsappRoundIcon({ className = 'w-4 h-4 fill-site-neutrals-800' }: GenericIconProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1125_12252)">
        <path d="M12.213 0C5.71307 0 0.424969 5.24836 0.424969 11.6995C0.424969 13.786 0.983358 15.8284 2.04115 17.6159L0.0165014 23.5883C-0.0212129 23.6996 0.00683904 23.8227 0.0892027 23.9066C0.148657 23.9673 0.229307 24 0.31167 24C0.343229 24 0.375021 23.9952 0.406034 23.9854L6.63357 22.0064C8.33772 22.917 10.2638 23.3976 12.2131 23.3976C18.7124 23.3977 24 18.1498 24 11.6995C24 5.24836 18.7124 0 12.213 0Z" />
        <path
          d="M17.7603 13.7914C17.7136 13.769 15.9639 12.9074 15.653 12.7955C15.5261 12.7499 15.3901 12.7054 15.2455 12.7054C15.0092 12.7054 14.8107 12.8232 14.6561 13.0544C14.4814 13.3142 13.9523 13.9327 13.7888 14.1174C13.7674 14.1418 13.7383 14.171 13.7208 14.171C13.7052 14.171 13.4344 14.0595 13.3524 14.0239C11.4755 13.2086 10.0509 11.248 9.85552 10.9173C9.82762 10.8698 9.82645 10.8482 9.82622 10.8482C9.83308 10.8231 9.89619 10.7598 9.92877 10.7271C10.0241 10.6328 10.1273 10.5086 10.2272 10.3883C10.2745 10.3314 10.3219 10.2743 10.3684 10.2206C10.5133 10.0519 10.5779 9.92103 10.6527 9.76939L10.6919 9.69062C10.8745 9.32773 10.7185 9.0215 10.6681 8.92262C10.6267 8.83986 9.88793 7.05685 9.80939 6.86952C9.62051 6.4175 9.37092 6.20703 9.02409 6.20703C8.99191 6.20703 9.02409 6.20703 8.88913 6.21272C8.72479 6.21965 7.82986 6.33747 7.43417 6.5869C7.01456 6.85145 6.30469 7.69472 6.30469 9.17773C6.30469 10.5125 7.1517 11.7727 7.51536 12.252C7.5244 12.2641 7.541 12.2886 7.56508 12.3238C8.95778 14.3578 10.694 15.8651 12.454 16.5682C14.1484 17.245 14.9508 17.3232 15.4069 17.3232H15.407C15.5987 17.3232 15.7521 17.3082 15.8875 17.2949L15.9733 17.2867C16.5587 17.2348 17.845 16.5683 18.1376 15.7551C18.3681 15.1147 18.4289 14.415 18.2755 14.161C18.1705 13.9883 17.9895 13.9014 17.7603 13.7914Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1125_12252">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default WhatsappRoundIcon;
